function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import IllegalArgumentException from '../../../../java/lang/IllegalArgumentException';
import Character from '../../../../java/lang/Character';
var Dimension = /*#__PURE__*/function () {
  function Dimension() {
    _classCallCheck(this, Dimension);
    Dimension.constructor_.apply(this, arguments);
  }
  return _createClass(Dimension, [{
    key: "getClass",
    value: function getClass() {
      return Dimension;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }], [{
    key: "toDimensionSymbol",
    value: function toDimensionSymbol(dimensionValue) {
      switch (dimensionValue) {
        case Dimension.FALSE:
          return Dimension.SYM_FALSE;
        case Dimension.TRUE:
          return Dimension.SYM_TRUE;
        case Dimension.DONTCARE:
          return Dimension.SYM_DONTCARE;
        case Dimension.P:
          return Dimension.SYM_P;
        case Dimension.L:
          return Dimension.SYM_L;
        case Dimension.A:
          return Dimension.SYM_A;
      }
      throw new IllegalArgumentException('Unknown dimension value: ' + dimensionValue);
    }
  }, {
    key: "toDimensionValue",
    value: function toDimensionValue(dimensionSymbol) {
      switch (Character.toUpperCase(dimensionSymbol)) {
        case Dimension.SYM_FALSE:
          return Dimension.FALSE;
        case Dimension.SYM_TRUE:
          return Dimension.TRUE;
        case Dimension.SYM_DONTCARE:
          return Dimension.DONTCARE;
        case Dimension.SYM_P:
          return Dimension.P;
        case Dimension.SYM_L:
          return Dimension.L;
        case Dimension.SYM_A:
          return Dimension.A;
      }
      throw new IllegalArgumentException('Unknown dimension symbol: ' + dimensionSymbol);
    }
  }]);
}();
export { Dimension as default };
Dimension.constructor_ = function () {};
Dimension.P = 0;
Dimension.L = 1;
Dimension.A = 2;
Dimension.FALSE = -1;
Dimension.TRUE = -2;
Dimension.DONTCARE = -3;
Dimension.SYM_FALSE = 'F';
Dimension.SYM_TRUE = 'T';
Dimension.SYM_DONTCARE = '*';
Dimension.SYM_P = '0';
Dimension.SYM_L = '1';
Dimension.SYM_A = '2';